// Consultant balances: what each consultant has earned from Consultant Fees on visits,
// less the payouts the clinic has recorded to them.

export const num = (v) => Number(v) || 0;

// Local calendar date (YYYY-MM-DD), not UTC, so evening entries in India keep today's date.
export const localToday = () => new Date().toLocaleDateString("en-CA");

export function consultantBalances(consultants, visits, settlements) {
  return consultants.map((c) => {
    const earned = visits.filter((v) => v.consultant_id === c.id).reduce((a, v) => a + num(v.consultant_fee), 0);
    const paid = settlements.filter((s) => s.consultant_id === c.id).reduce((a, s) => a + num(s.amount), 0);
    return { consultant: c, earned, paid, outstanding: earned - paid };
  });
}
